import { MarbleItem } from 'src/components/MarbleItem'
import { useMarblePositionLabel } from 'src/hooks/useMarblePositionLabel'
import { useClientSideTranslation } from 'src/services/i18n'
import { getTranslatedMarbleColor } from 'src/services/i18n/utils/gameTranslations'
import { useGetCurrentLanguage } from 'src/store/game'
import type { Marble } from 'src/types/domain/Marble'

type Props = Readonly<{
  position: number
  isWinningMarble: boolean
  marble: Marble
}>

export function BetHistoryMarbleWrapper({ isWinningMarble, position, marble }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())
  const positionLabel = useMarblePositionLabel(position)
  const translatedColor = getTranslatedMarbleColor(marble.color, t)

  return (
    <MarbleItem
      className={`${isWinningMarble ? 'winning-marble' : ''} marble-${marble.color}`}
      key={marble.number}
      marble={marble}
      tooltip={position ? `${translatedColor} -> ${positionLabel}` : translatedColor}
    />
  )
}
